import React from 'react';

const Publications: React.FC = () => {
  const books = [
    {
      title: "CI/CD Design Patterns",
      description: "A comprehensive guide to implementing modern CI/CD practices and patterns in your organization.",
      link: "https://www.packtpub.com/en-us/product/cicd-design-patterns-9781835889657",
      coverImage: "/images/cicddesignpatterns.webp",
      year: "2024"
    }
  ];

  const articles = [
    {
      title: "DevOps articles",
      description: "I write on dev.to articles about AWS, CI/CD, Docker, IaC and much more.",
      platform: "dev.to",
      link: "https://dev.to/pawelpiwosz"
    },
    {
      title: "DevOps articles",
      platform: "Medium",
      description: "Like on dev.to, but I also cover here some soft topics too.",
      link: "https://medium.com/@pawelpiwosz/"
    }
  ];

  const youtubeChannel = {
    title: "DevOps in Agile Way",
    description: "Subscribe to my YouTube channel for videos on AWS, DevOps, CI/CD, Docker, and more.",
    link: "https://www.youtube.com/@devopsinagileway",
    coverImage: "/images/youtube-channel-cover.png"
  };

  const youtubeChannel2 = {
    title: "OhMyCloud!",
    description: "Together with Rafal we present you videocast about clouds, architecture and the whole IT world. Channel mainly in Polish.",
    link: "https://www.youtube.com/@ohmycloud-pl",
    coverImage: "/images/youtube-channel-ohmycloud-cover.png"
  };

  return (
    <div className="page publications">
      <div className="container">
        <h1>Publications</h1>

        <section className="books-section">
          <h2>Books</h2>
          <div className="books-grid">
            {books.map((book) => (
              <div key={book.title} className="book-card">
                <img src={book.coverImage} alt={book.title} className="book-cover" />
                <div className="book-content">
                  <h3>{book.title}</h3>
                  <p>{book.description}</p>
                  <span className="year">{book.year}</span>
                  <a href={book.link} target="_blank" rel="noopener noreferrer" className="book-link">
                    Learn More
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="youtube-section">
          <h2>YouTube Channel</h2>
          <div className="youtube-card">
            <div className="youtube-content">
              <h3>{youtubeChannel.title}</h3>
              <p>{youtubeChannel.description}</p>
              <a href={youtubeChannel.link} target="_blank" rel="noopener noreferrer" className="youtube-link">
                Visit Channel
              </a>
            </div>
            <img src={youtubeChannel.coverImage} alt={youtubeChannel.title} className="youtube-cover" />
          </div>
          <div className="youtube-card">
            <div className="youtube-content">
              <h3>{youtubeChannel2.title}</h3>
              <p>{youtubeChannel2.description}</p>
              <a href={youtubeChannel2.link} target="_blank" rel="noopener noreferrer" className="youtube-link">
                Visit Channel
              </a>
            </div>
            <img src={youtubeChannel2.coverImage} alt={youtubeChannel2.title} className="youtube-cover" />
          </div>
        </section>

        <section className="articles-section">
          <h2>Articles & Blog Posts</h2>
          <div className="articles-grid">
            {articles.map((article) => (
              <div key={article.title} className="article-card">
                <span className="platform-badge">{article.platform}</span>
                <h3>{article.title}</h3>
                <p>{article.description}</p>
                <div className="article-footer">
                  <a href={article.link} target="_blank" rel="noopener noreferrer" className="article-link">
                    Read Articles
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Publications;